import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["feedback", "strengthFill", "strengthLabel", "strengthScore", "feedbackContainer", "feedbackContent"]
  static STRENGTH_LABELS = [
    'Very Weak',
    'Weak',
    'Fair',
    'Good',
    'Strong'
  ];

  connect() {
  }

  checkStrength() {
    const password = event.target.value;

    if (!password) {
      // Reset to initial state
      this.strengthFillTarget.style.width = '0%';
      this.strengthFillTarget.className = 'strength-fill';
      this.strengthLabelTarget.textContent = '';
      this.strengthLabelTarget.className = 'strength-label';
      this.strengthScoreTarget.textContent = 'Score: -';
      this.feedbackContainerTarget.style.display = 'none';
      this.feedbackTarget.style.display = 'none';
      return;
    } else {
      this.feedbackTarget.style.display = 'block'
    }

    const result = zxcvbn(password);

    // Update strength bar
    const score = result.score;
    const percentage = ((score + 1) / 5) * 100;
    this.strengthFillTarget.style.width = `${percentage}%`;
    this.strengthFillTarget.className = `strength-fill score-${score}`;

    // Update strength text
    this.strengthLabelTarget.textContent = this.constructor.STRENGTH_LABELS[score];
    this.strengthLabelTarget.className = `strength-label score-${score}`;
    this.strengthScoreTarget.textContent = `Score: ${score}/4`;

    // Update feedback
    this.feedbackContentTarget.innerHTML = '';

    if (result.feedback.warning) {
      const warningDiv = document.createElement('div');
      warningDiv.className = 'feedback-item warning';
      warningDiv.textContent = `${this.capitalizeFirst(result.feedback.warning)}`;
      this.feedbackContentTarget.appendChild(warningDiv);
    }

    result.feedback.suggestions.forEach(suggestion => {
      const suggestionDiv = document.createElement('div');
      suggestionDiv.className = 'feedback-item suggestion';
      suggestionDiv.textContent = `${this.capitalizeFirst(suggestion)}`;
      this.feedbackContentTarget.appendChild(suggestionDiv);
    });

    if (result.feedback.warning || result.feedback.suggestions.length > 0) {
      this.feedbackContainerTarget.style.display = 'block';
    } else {
      this.feedbackContainerTarget.style.display = 'none';
    }
  }

  capitalizeFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
